import type { Language } from "@app/constants";

interface Messages {
	amountInvested: string;
	download: string;
	netProfit: string;
	netReturn: string;
	statement: string;
}

type Message = { [key in Language]: Messages };

const messages: Message = {
	en: {
		amountInvested: "Amount Invested",
		download: "Download",
		netProfit: "Net Profit",
		netReturn: "Net Return",
		statement: "Statement",
	},
};

export default messages;
